import convertImageToBase64 from '../../utils/converitr-imagen-base64';
import { formSchema } from '../../validaciones/validacionPlatillos';

export const formularioPlatillosSlice = (set,get) => ({
    nivel_de_picante: [{value:0,label:"0"},{value:1,label:"1"},{value:2,label:"2"},{value:3,label:"3"}],
    estatus: [{value:1,label:"Activo"},{value:2,label:"No Disponible"},{value:3,label:"Oculto"}],
    obtenerCategoriaPlatillo: () => {
        fetch("/p_platillos_sucursal_categoria")
        .then((res) => res.json())
        .then((data) => {
            console.log('la datas',data);
            if(data.status === 1){
                set({ categoriasPlatillo: data.data.map((item) => { return { value: item.ID_CP, label: item.NOMBRE_CP } }), isLoading: {...get().isLoading,cargarSucursalCategoria: false} })
            }
        });
    },
    handleChange: (e) => set({ datos:{ ...get().datos, [e.target.name]: e.target.value } }),
    handleSave: () => {

        const result = formSchema.safeParse({ ...get().datos, multiImagenes: get().multiImagenes, sucursalesPlatillo: get().sucursalesPlatillo });
        if (!result.success) {
            console.log(result.error.errors);
            console.log(result.error.flatten().fieldErrors);
            set({error:result.error.flatten().fieldErrors})
            return;
        }
        else{
            set({error:null})
        }

        const formData = new FormData();
        let datosImagnes = []
        for(let i = 0; i < get().multiImagenes.length; i++){
            if(get().multiImagenes[i].esNuevo){
                formData.append('miArchivo', get().multiImagenes[i].file);
            }
            datosImagnes.push({
                nombre: get().multiImagenes[i].nombre,
                pos: i + 1,
            })
        }
        formData.append('datosImagenes', JSON.stringify(datosImagnes));
        formData.append('datos', JSON.stringify(get().datos));
        formData.append('sucursalesPlatillo', JSON.stringify(get().sucursalesPlatillo));
        if (get().datos.id == 0) {
          try {
            fetch("/p_platillo",{
            method: "POST",
            body: formData
            })
            .then((res) => res.json())
            .then((data) => {
              console.log(data);
              if(data.status === 1){
                  // Success
                  get().elNavigate(-1);
              }
              });
          } catch (error) {
              console.error('Error:', error);
          }
        }
        else {
            console.log('Entrando actualizar');
          
          try {
            fetch("/p_platillo",{
              method: "PUT",
              /* headers:{
                  "Content-Type": "application/json",
              }, */
              body: formData
              })
              .then((res) => res.json())
              .then((data) => {
              console.log(data);
              if(data.status === 1){
                  // Success
                  get().elNavigate(-1);
              }
            });
          } catch (error) {
              console.error('Error:', error);
          }
        }
    },
    obtenerPlatillo: () => {
        if(get().datos.id != 0){
            fetch("/p_platillo",{
                method: "PATCH",
                headers:{
                "Content-Type": "application/json",
                },
                body: JSON.stringify({id:get().datos.id})
            })
            .then((res) => res.json())
            .then(async (data) => {
                console.log('PLATILLO',data);
                if(data.status === 1){
                    set({datos:{
                        ...get().datos,
                        id_cp:data.data[0][0].ID_CP_PLA.toString(),
                        nombre:data.data[0][0].NOMBRE_PLA,
                        descripcion:data.data[0][0].DESCRIPCION_PLA,
                        precio:data.data[0][0].PRECIO_PP.toString(),
                        nivel_picante:data.data[0][0].NIVEL_PICANTE_PLA.toString(),
                        tiempo:data.data[0][0].TIEMPO_PREPARACION_PLA.toString(),
                        es_nuevo:data.data[0][0].ES_NUEVO_PLA,
                        estatus:data.data[0][0].ESTATUS_PLA
                    }});
                    set({sucursalesPlatillo:data.data[1].map((item) => { return { value: item.ID_SUC, label: item.NOMBRE_SUCURSAL_SUC } })});

                    let imagenesPlatillos = []
                    for(let i = 0; i < data.data[2].length; i++){
                        let laImagen = `/platillo/${get().datos.id}/${data.data[2][i].NOMBRE_PLI}`;
                        let base64 = await convertImageToBase64(laImagen);
                        imagenesPlatillos.push({
                            id:data.data[2][i].ID_PLI,
                            nombre:data.data[2][i].NOMBRE_PLI,
                            file:null,
                            esNuevo:false,
                            preview:base64,
                        })
                    }

                    console.log('imagenesPlatillos',imagenesPlatillos);

                    set({multiImagenes:imagenesPlatillos});

                    set({isLoading:{...get().isLoading,cargarPlatillo:false}});
                }
            });
        }
        else{
            set({isLoading:{...get().isLoading,cargarPlatillo:false}});
        }
    },
    duplicarPlatillo: () => {
        try {
            fetch("/p_platillo_duplicar",{
                method: "POST",
                headers:{
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({id:get().datos.id})
                })
                .then((res) => res.json())
                .then((data) => {
                console.log(data);
                if(data.status === 1){
                    // Success
                    window.location.href = '/platillos';
                }
            });
        } catch (error) {
                console.error('Error:', error);
        }
    },
})